export default "__VITE_ASSET__BGthM9PL__"